// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-public-alert-dialog {
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 480px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/EntryDialogues/DialogSwitchPublic/DialogPublic/DialogAlert/DialogAlert.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AACJ","sourcesContent":[".dl-public-alert-dialog {\n  box-sizing: border-box;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 480px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
